import axios from "axios";
import { setIsLogin, setUser } from "../Redux Store/Slice";

export const checkAuth = () => async (dispatch) => {
  const token = localStorage.getItem("token");

  if (!token) {
    dispatch(setIsLogin(false));
    return;
  }

  try {
    const res = await axios.get("https://e7d893ac-1fc1-4467-aa15-da8df52d7f2b-00-uwkf7bnur9r5.riker.replit.dev:8000/auth/me", {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log("middleware : ", res.data)
    dispatch(setIsLogin(true));
    dispatch(setUser(res.data.user));
  } catch (err) {
    // token invalid
    console.error("Auth check failed:", err);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(setIsLogin(false));
  }
};
